import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import Button from 'components/Button/Button';
import routes from 'enum/routeDefinitions';
import { generateID } from 'utils/helpers';

import styles from '../index.css';


const IDS = {
  prefix: 'B0lLaRIC',
  element: 'cookieConsent',
  button: 'consentCookieBtn',
  cookieLink: 'cookie-link',
  settingsLink: 'settings-link',
};
const makeId = generateID(IDS.prefix, IDS.element);

const CookiePolicy = (props) => {
  const { username, onAccept } = props;

  const link = useMemo(() => `
    <a
      class=${styles.promptLink}
      href=${routes.cookies}
      target="_blank"
      id=${makeId(IDS.cookieLink)}
    >
  `, []);

  const linkLoggedIn = useMemo(() => `
    <a
      class=${styles.promptLink}
      href=${routes.get(routes.accountPrivacy, { user: username })}
      target="_blank"
      id=${makeId(IDS.settingsLink)}
    >
  `, [username]);

  const text = useMemo(() => {
    if (username) {
      return (
        translate('disclaimer.disclaimer.cookies.text5', {
          0: linkLoggedIn,
          1: '</a>',
          2: link,
          3: '</a>',
        })
      );
    }

    return (
      translate('disclaimer.disclaimer.cookies.text4', {
        0: link,
        1: '</a>',
      })
    );
  }, [link, linkLoggedIn, username]);

  return (
    <div className={styles.pod}>
      <span className={styles.cookieIcon} />

      <div className={styles.description}>
        <div className={styles.promptText}>
          {text}
        </div>

        <Button
          className={styles.button}
          colour="broadcasterBlack"
          id={makeId(IDS.button)}
          size="small"
          onClick={onAccept}
        >
          {translate('disclaimer.disclaimer.cookies.button')}
        </Button>
      </div>
    </div>
  );
};

CookiePolicy.propTypes = {
  onAccept: PropTypes.func.isRequired,
  username: PropTypes.string,
};

CookiePolicy.defaultProps = {
  username: undefined,
};

export default observer(CookiePolicy);
